import React, { useEffect } from 'react';
import { Box, IconButton, Stack, Typography, Tooltip } from '@mui/material';
import CloseOutlined from '@mui/icons-material/CloseOutlined';
import { useStylesHook } from 'src/hooks/utilHooks';
import { getStyles } from 'src/asio-neon-components/Layouts/layoutStyles';
import AlertNotificationContainer from 'src/asio-neon-components/AlertNotification/AlertNotificationContainer';
import PropTypes from 'prop-types';
import { ACTIVE_SCREEN_KEY } from 'cw-ui-core';
import { EDIT_EXTERNAL_IDP, EDIT_DUO_MFA } from 'src/features/authentication-v2/constants';
import { clearAlertMessages } from 'src/features/authentication-v2/components/utils';
import { useRouting } from '../Utils';

function FullPageLayout(props) {
    const {
        onCloseIconClicked,
        className,
        PageTitle = <Typography />,
        actions,
        children,
        screenKey = ACTIVE_SCREEN_KEY,
    } = props;
    const styles = useStylesHook(getStyles);
    const { goBack } = useRouting();
    useEffect(() => {
        return () => {
            clearAlertMessages(screenKey);
        };
    }, []);
    const isEditMode = screenKey === EDIT_DUO_MFA || screenKey === EDIT_EXTERNAL_IDP;
    const tooltipText = isEditMode ? PageTitle.props.children.slice(-1) : PageTitle;
    return (
        <Box style={styles.container} className={className}>
            <Box sx={{ position: 'absolute', mx: 'auto', top: 5, width: '60%', left: 0, right: 0 }}>
                <AlertNotificationContainer screenKey={screenKey} />
            </Box>
            <Stack sx={styles.title}>
                <Stack width="88%">
                    {isEditMode ? (
                        <Tooltip
                            type="standard"
                            title={tooltipText}
                            placement="bottom-start"
                            arrow
                            sx={styles.titleHover}>
                            <Typography variant="h4">{PageTitle}</Typography>
                        </Tooltip>
                    ) : (
                        <Typography variant="h4">{PageTitle}</Typography>
                    )}
                </Stack>
                <Stack flexDirection="row" gap={1} alignItems="center" width="12%" justifyContent="flex-end">
                    {actions}
                    <IconButton
                        style={styles.closeIcon}
                        size="large"
                        onClick={onCloseIconClicked || goBack}
                        aria-label="close">
                        <CloseOutlined color="primary" fontSize="inherit" />
                    </IconButton>
                </Stack>
            </Stack>
            <Box style={styles.content}>{children}</Box>
        </Box>
    );
}

FullPageLayout.propTypes = {
    onCloseIconClicked: PropTypes.func,
    className: PropTypes.string,
    PageTitle: PropTypes.node,
    actions: PropTypes.node,
    screenKey: PropTypes.string,
};

FullPageLayout.defaultProps = {
    className: '',
    onCloseIconClicked: null,
    actions: null,
    PageTitle: <Typography />,
    screenKey: ACTIVE_SCREEN_KEY,
};

export default FullPageLayout;
